// Curated venue imagery for The Epic Center Birmingham
// Real venue photos
export const LOGO = "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/6931legp_Convert%20Image%20to%20White%20%28Transparent%20BG%29.webp";

export const REAL = {
  exterior: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/7tf3ydam_IMG_2389.jpeg",
  hallBright: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/9xeu0eb0_IMG_2717.jpeg",
  hallMoody: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/zghxerg1_IMG_2386.jpeg",
  music: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/6s267gcs_IMG_3193.jpeg",
  lounge: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/ecgti5gq_62EABC4A-D60C-4B0B-80A9-C5D496FC4A43.jpeg",
  pool: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/kk4kywkk_IMG_3190.jpeg",
  hallArt: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/bxw18ln4_IMG_3189.jpeg",
  bar: "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/n2xrwos8_IMG_3187.jpeg",
};

export const HERO_SLIDES = [
  { url: REAL.hallMoody, label: "The Epic Center — Event Hall" },
  { url: REAL.lounge, label: "VIP Lounge" },
  { url: REAL.music, label: "Live Music & Performance" },
  { url: REAL.hallBright, label: "Full Venue Setup" },
  { url: REAL.exterior, label: "1301 3rd Avenue West" },
];

export const ABOUT_IMG_MAIN = REAL.hallBright;
export const ABOUT_IMG_SUB = REAL.exterior;

export const GLOBAL_ROOM_IMG = REAL.hallBright;
export const CITY_ROOM_IMG = REAL.hallMoody;

export const BOOKING_IMG = REAL.lounge;

export const GALLERY = [
  REAL.hallMoody,
  REAL.music,
  REAL.lounge,
  REAL.hallBright,
  REAL.pool,
  REAL.bar,
  REAL.hallArt,
  REAL.exterior,
];

export const TESTIMONIALS = [
  { quote: "The perfect venue for our wedding reception. Every detail felt elevated and intentional.", author: "Marcus & Tiana", role: "Wedding Reception" },
  { quote: "Beautiful, spacious, and professional. The team made our conference seamless.", author: "Bham Black Business Coalition", role: "Corporate Conference" },
  { quote: "West Birmingham needed this. A true home for culture and celebration.", author: "Denise R.", role: "Community Brunch" },
  { quote: "The lighting, the sound, the energy — our concert sold out and felt world class.", author: "DJ Soul Theory", role: "Live Concert" },
];
